import * as Request from '../Request';
const RiskLibrary = {
  /**
   * 风险点
   * @param data
   * @returns {*}
   */
  // 新增
  fxSave: (data) => {
    return Request.post('/fxDB/save', data)
  },
  // 编辑
  fxUpdate: (data) => {
    return Request.put('/fxDB/update', data)
  },
  // 详情
  fxInfo: (data) => {
    return Request.get('/fxDB/info', data)
  },
  // 删除
  fxDel: (data) => {
    return Request.delBody('/fxDB/delete', data)
  },
  // 列表
  fxList: (data) => {
    return Request.post('/fxDB/list', data)
  },
  // 获取风险点类型（风险辨识通用库）
  getRiskPtTypeList: (data) => {
    return Request.get('/fxDB/type/list', data)
  },
  // 获取行业分类列表(风险辨识通用库)
  getIndustryTypeList: (data) => {
    return Request.get('/fxDB/industry/list', data)
  },
  /**
   * 危险有害因素
   * @param data
   * @returns {*}
   */
  // 新增
  harmFactorSave: (data) => {
    return Request.post('/fxDB/harmFactor/save', data)
  },
  // 编辑
  harmFactorUpdate: (data) => {
    return Request.put('/fxDB/harmFactor/update', data)
  },
  // 详情
  harmFactorInfo: (data) => {
    return Request.get('/fxDB/harmFactor/info', data)
  },
  // 删除
  harmFactorDel: (data) => {
    return Request.delBody('/fxDB/harmFactor/delete', data)
  },
  // 列表
  harmFactorList: (data) => {
    return Request.post('/fxDB/harmFactor/list', data)
  },
  // 风险等级列表
  getRiskGradeList: (data) => {
    return Request.get('/fxDB/harmFactor/grade/list', data)
  },
  // 获取风险评估工具列表
  getRiskAssessList: (data) => {
    return Request.get('/fxDB/harmFactor/decisionMethod/list', data)
  },
  // 事故类型列表
  getAccidentTypeList: (data) => {
    return Request.get('/fxDB/harmFactor/accidentType/list', data)
  },
  // 获取事件
  getTypeList: (data) => {
    return Request.get('/fx/accident/type/list?status=1&time=null')
  }
}
export default RiskLibrary
